import TrainingPrograms from 'modules/training/training-programs/Main';
import AddTrainingPrograms from 'modules/training/training-programs/add-training-programs/Main';
import AddTraining from 'modules/training/training-programs/add-new-training/Main';
import AddTemplate from 'modules/training/training-programs/add-new-template/Main';
import ExternalTrainingPrograms from 'modules/training/training-programs/add-external-traning-programs/Main';
import ViewTraining from 'modules/training/training-programs/view-training-programs/Main';
import TrainingWrapper from 'modules/training/TrainingWrapper';
import EditTrainingProgram from 'modules/training/training-programs/edit-training-program/Main';
// import UserSecurityPage from 'modules/home/manage-clients/dashboard/usersettings/UserSecurityPage';

const TrainingRoutes = (): any => ({
  path: '',
  element: <TrainingWrapper />,
  children: [
    {
      path: 'training-programs',
      element: <TrainingPrograms />,
    },
    {
      path: 'training-programs/view/:trainingId',
      element: <ViewTraining />,
    },
    {
      path: 'training-programs/edit/:trainingId',
      element: <EditTrainingProgram />,
    },
    {
      path: 'training-programs/training',
      element: <AddTraining />,
    },
    {
      path: 'training-programs/training-template',
      element: <AddTemplate />,
    },
    {
      path: 'training-programs/add',
      element: <AddTrainingPrograms />,
    },
    {
      path: 'training-programs/add-ready-to-use-template/:templateId',
      element: <AddTrainingPrograms purpose="ready-to-use" />,
    },
    {
      path: 'training-programs/add-external-training-programs',
      element: <ExternalTrainingPrograms />,
    },
  ],
});

export default TrainingRoutes;
